<template>
  <div
    class="property-view-page  bg-black text-primary-color outside-advertise pt-0"
  >
    <section class="property-heading flex items-center" v-if="property">
      <div class="advertise-container mx-auto grid grid-cols-1 gap-16">
        <div>
          <div class="grid grid-cols-7 items-center">
            <div class="col-span-5">
              <h2>
                <b class="text-5xl">LONG LET - </b>{{ property.city.name }}
              </h2>
              <p class="capitalize">
                {{ property.property_type.classification }} -
                {{ property.property_type.name }}
              </p>
            </div>
            <div class="col-span-2 text-right">
              <div class="price">
                <h2>
                  &euro;{{ property.price }}
                  <small class="font-normal"> monthly</small>
                </h2>
              </div>
            </div>
          </div>
          <div
            class="col-span-2 my-12 grid grid-cols-2 gap-16"
            v-if="property.photos.length"
          >
            <div
              v-for="(propertyImage, index) in propertyImages"
              :key="index"
              class="flex justify-center items-center"
            >
              <img
                class="w-full rounded-xl"
                :src="`${baseImageUrl}/storage/${propertyImage.image}`"
                style="max-height: 350px; width: auto"
                alt="1.jpg"
              />
            </div>
          </div>
        </div>
        <div class="pt-4">
          <div class="p-6 border border-primary-color rounded-lg mb-6">
            <div class="tags mb-6">
              <ul>
                <li>{{ property.property_type.name }}</li>
                <li>Beds: {{ property.bedrooms }}</li>
                <li>
                  Baths: {{ property.main_bathrooms + property.ensuites }}
                </li>
              </ul>
            </div>
            <h4 class="mb-4">Description</h4>
            <p>
              {{ property.description }}
            </p>
          </div>
          <div class="p-6 border border-primary-color rounded-lg mb-6">
            <h4 class="mb-8">Property Details</h4>
            <div class="grid grid-cols-3 gap-6 gap-y-4">
              <div class="grid grid-cols-2">
                <p>Property ID :</p>
                <p class="font-bold">{{ property.ref_no }}</p>
              </div>
              <div class="grid grid-cols-2">
                <p>Price :</p>
                <p class="font-bold">&euro;{{ property.price }} monthly</p>
              </div>
              <div class="grid grid-cols-2" v-if="property.floor_area">
                <p>Size :</p>
                <p class="font-bold">{{ property.floor_area }} sqm</p>
              </div>
              <div class="grid grid-cols-2">
                <p>Bedrooms :</p>
                <p class="font-bold">{{ property.bedrooms }}</p>
              </div>
              <div class="grid grid-cols-2">
                <p>Main Bathrooms :</p>
                <p class="font-bold">{{ property.main_bathrooms }}</p>
              </div>
              <div class="grid grid-cols-2">
                <p>Ensuites :</p>
                <p class="font-bold">{{ property.ensuites }}</p>
              </div>
              <div class="grid grid-cols-2">
                <p>Type :</p>
                <p class="font-bold">{{ property.property_type.name }}</p>
              </div>
            </div>
          </div>

          <div v-if="false" class="p-6 border border-gray-400 rounded-lg">
            <h4 class="mb-8">Property Amenities</h4>
            <div class="grid grid-cols-3 gap-4 gap-y-4">
              <div
                class="text-primary-color flex items-center"
                v-for="(amenity, index) in amenities"
                :key="index"
              >
                <font-awesome-icon :icon="['fas', 'check']" class="mr-4" />
                <p class="text-black">{{ amenity }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { LISTING_TYPES } from "@/constants";

export default {
  props: ["id"],
  data: function() {
    return {
      LISTING_TYPES,
      baseImageUrl: process.env.VUE_APP_API_URL,
      currentImage: 0,
      viewingProperty: 0,
    };
  },
  computed: {
    ...mapGetters("Properties", {
      properties: "properties",
    }),
    advertisedProperty() {
      return this.properties.filter((p) => p.is_advertised);
    },
    property() {
      return this.advertisedProperty[this.viewingProperty];
    },
    propertyImages() {
      return this.property.photos.slice(0,4);
    },
  },
  methods: {
    ...mapActions("Properties", {
      getProperties: "getProperties",
    }),
  },
  beforeMount: function() {
    this.getProperties({
      limit: 99999,
    });
  },
  mounted() {
    setInterval(() => {
      if (this.viewingProperty < this.advertisedProperty.length - 1) {
        this.viewingProperty++;
      } else {
        this.viewingProperty = 0;
      }
    }, 10000);
  },
};
</script>

<style scoped lang="scss">
.outside-advertise {
  height: 100vh;
}

.outside-advertise .property-heading {
  height: 100% !important;
}

.tags {
  @apply text-black;

  ul li {
    @apply inline-block bg-primary-color px-4 py-2 rounded-md mr-2 text-black font-medium;
  }
}
.advertise-container,
.container {
  width: 100% !important;
  max-width: 90% !important;
}
</style>
